import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import * as firebase from 'firebase';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import "./generalScreens.css";
import { uuid } from 'uuidv4';

var ref;



export default class CreateEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // add default values so that people can navigate directly to the page if they want to without it crashing
            // picker or standardized input for time                IN THE FUTURE
            // specify "start date" for date                        ???
            title: '',//this.props.location.data.eventName,
            price: '',
            description: '',
            timeStart: '',
            timeEnd: '',
            address: '',
            city: '',
            date: '',
            flyer: '',
            state_: '',
            zipCode: '',
            eventTopic: uuid() + String(Math.random()),
            ticketCtrl: [],
            tickCount: '',
            tickPrice: '',
            // hostID: firebase.auth().currentUser.uid,
            // stripeID: 


            imgURL: '',
            imgBlob: '',
            complete: false
        }
    }

    displayFlyer = (e) => {
        try {
            var file = e.target.files[0];
            // console.log('file= ' + file)
            this.setState({
                flyer: URL.createObjectURL(file),
                imgBlob: e
            })
            e.persist();
        }
        catch (err) {
            console.log('displayFlyer() error: ' + err.message)
        }
    }

    uploadFlyer = async () => {
        try {
            var file = this.state.imgBlob.target.files[0];

            const name = this.state.title;
            const number = Math.random() * 10 + 100;
            ref = firebase.storage().ref('allEventFlyers/' + name + '/').child(name + '_' + number.toString());


            async function upld() {
                const task = await ref.put(file);
                return new Promise((async () => {
                    const url = await ref.getDownloadURL()
                        .then(() => {
                            this.setState({ imgURL: url });
                            console.log('url= ' + url);
                        })

                }, (err) => {

                    console.log(err)

                }))
            }
            // }

            upld();
            // setTimeout(() => {
            //     try {

            //     }
            //     catch (err) {
            //         console.log(err.message);
            //     }
            // }, 2000)

            // },
            //     (err) => {
            //         console.log(`Error: +${err.message}`)
            //  });

            // const finish = await Promise.all(upld);

            // return          //add resolve && reject functions??
            // setTimeout(() => {

            // }, 2000);


        }
        catch (err) {
            console.log('upload fail: ' + err.message)
            console.log('uploadImage error: ' + err.message);
        }

    }

    onSubmit = async () => {
        const condition = (this.state.title === '' ||/* this.state.price < 0 || this.state.price === '' || */this.state.description === '' || this.state.timeStart === '' || this.state.timeEnd === '' || this.state.address === '' || this.state.city === '' || this.state.date === '' || this.state.flyer === '' || this.state.state_ === '' || this.state.zipCode === '');   //add ticketCtrl
        if (condition) return;
        else {
            try {
                this.uploadFlyer().then(() => {
                    // firebase.firestore().collection('events').doc(this.state.eventTopic)
                    firebase.firestore().collection('test').doc('testEvent').collection('events').doc(this.state.eventTopic)            //TESTING
                        .set({
                            TICKETMAX: this.state.ticketCtrl[0].count,
                            endTime: this.state.timeEnd,
                            eventAddress: this.state.address,
                            eventCity: this.state.city,
                            eventDJ: '',
                            eventDate: this.state.date,
                            eventDescription: this.state.description,
                            eventFlyer: this.state.imgURL,
                            eventName: this.state.title,
                            eventPrice: this.state.ticketCtrl[0].price,
                            eventState: this.state.state_,
                            eventTopic: this.state.eventTopic,
                            eventZip: this.state.zipCode,
                            doorPrice: this.state.ticketCtrl[0].price,
                            hostID: '',
                            hostID2: '',
                            hostID3: '',
                            hostID4: '',
                            hostID5: '',
                            hostName: '',
                            partyStateEnded: false,
                            partyType: 'house',
                            priceRule: 'sequential',
                            saleState: false,
                            startTime: this.state.timeStart,
                            ticketCount: this.state.ticketCtrl[0].count,
                            ticketCtrl: this.state.ticketCtrl,

                        }).then(() => {
                            // firebase.firestore().collection('eventsLimited').doc(this.state.eventTopic)
                            firebase.firestore().collection('test').doc('testEvent').collection('eventsLimited').doc(this.state.eventTopic)         //TESTING
                                .set({
                                    eventDate: this.state.date,
                                    eventFlyer: this.state.imgURL,
                                    eventLocation: this.state.address,
                                    eventName: this.state.title,
                                    eventPrice: this.state.ticketCtrl[0].price,
                                    eventTopic: this.state.eventTopic,
                                    partyStateEnded: false,
                                    startTime: this.state.timeStart,
                                })
                        }).then(async () => {
                            setTimeout(async () => {
                                const putMeIn = await ref.getDownloadURL();
                                // firebase.firestore().collection('events').doc(this.state.eventTopic).update({
                                firebase.firestore().collection('test').doc('testEvent').collection('events').doc(this.state.eventTopic)            //TESTING
                                    .update({
                                        eventFlyer: putMeIn,
                                    })
                                firebase.firestore().collection('eventsLimited').doc(this.state.eventTopic)
                                // firebase.firestore().collection('test').doc('testEvent').collection('eventsLimited').doc(this.state.eventTopic)     //TESTING
                                .update({
                                    eventFlyer: putMeIn,
                                })
                            }, 5000)

                        });
                },
                    (err) => {
                        console.log(`Error uploading: ${err.message}`);
                    });


            }
            catch (err) {
                console.log('onSubmit() error: ' + err.message)
            }
        }
    }

    render() {
        return (
            <div className="column-create-event" style={{ textAlign: 'center' }}>
                <h1>Create Event</h1>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '81.24px' }} >Flyer:</h4>
                    <input
                        type='file'
                        style={{ outlineColor: 'rgb(29, 185, 84)', width: '382px' }}
                        onChange={this.displayFlyer}
                    />

                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '87.45px' }}>Title:</h4>
                    <input
                        type='text'
                        placeholder='ex: X-Sell'
                        value={this.state.title}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ title: text.target.value });
                        }}
                    />
                </div>

                <div className='row-start'  >
                    <h4 style={{ paddingRight: '55.45px' }} >Price: $</h4>
                    <input
                        type='number'
                        placeholder='ex: 9.99'
                        min='0'
                        value={this.state.price}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ price: Number(text.target.value) });
                            // console.log(this.state.price);
                        }}
                    />
                </div>
                <div className='row-start'  >
                    <h4>Description: </h4>
                    <textarea
                        type='text'
                        rows='5'
                        cols='40'
                        placeholder="ex: This is a description. Describe your event to your heart's content!"
                        value={this.state.description}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ description: text.target.value });
                            // console.log(this.state.description);
                        }}
                    />


                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '13.83px' }}>Start Time:</h4>
                    <input
                        type='text'
                        placeholder='ex: 10:00 pm'
                        value={this.state.timeStart}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ timeStart: text.target.value });
                            // console.log(this.state.timeStart);
                        }}
                    />
                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '26.94px' }} >End Time: </h4>
                    <input
                        type='text'
                        placeholder='ex: 1:00 am'
                        value={this.state.timeEnd}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ timeEnd: text.target.value });
                            // console.log(this.state.timeEnd);
                        }}
                    />
                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '83.6px' }} >Date: </h4>
                    <input
                        type='text'
                        placeholder='ex: September 28, 2019'
                        value={this.state.date}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ date: text.target.value });
                            // console.log(this.state.date);
                        }}
                    />
                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '39.97px' }} >Address: </h4>
                    <input
                        type='text'
                        placeholder='ex: 123 Sesame Street'
                        value={this.state.address}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ address: text.target.value });
                            // console.log(this.state.address);
                        }}
                    />
                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '91.63px' }} >City: </h4>
                    <input
                        type='text'
                        placeholder='ex: Washington'
                        value={this.state.city}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ city: text.target.value });
                            // console.log(this.state.city);
                        }}
                    />
                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '76.56px' }} >State: </h4>
                    <input
                        type='text'
                        placeholder='ex: D.C.'

                        value={this.state.state_}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ state_: text.target.value });
                            // console.log(this.state.state_);
                        }}
                    />
                </div>
                <div className='row-start' >
                    <h4 style={{ paddingRight: '29.38px' }} >Zip Code: </h4>
                    <input
                        type='text'
                        placeholder='ex: 20059'
                        value={this.state.zipCode}
                        style={{ outlineColor: 'rgb(29, 185, 84)' }}
                        onChange={(text) => {
                            this.setState({ zipCode: text.target.value });
                            // console.log(this.state.zipCode);
                        }}
                    />
                </div>
                <div className='row-start' style={{ paddingBottom: 10 }} >
                    <h4>Add Prices</h4>
                    <input type='number' placeholder='count' value={this.state.tickCount} onChange={(char) => {
                        this.setState({ tickCount: Number(char.target.value) });
                    }}
                    />
                    <input type='number' placeholder='price' value={this.state.tickPrice} onChange={(char) => {
                        this.setState({ tickPrice: Number(char.target.value) });
                    }}
                    />
                    <Button className='button' onClick={() => {
                        let newTick = {
                            count: this.state.tickCount,
                            price: this.state.tickPrice
                        };

                        this.state.ticketCtrl.push(newTick);
                        this.setState({
                            tickCount: '',
                            tickPrice: '',
                        });
                        // console.log('added' + '\n' + JSON.stringify(newTick));
                        console.log('ticketCtrl' + '\n' + JSON.stringify(this.state.ticketCtrl));
                    }} >Add Ticket</Button>
                </div>
                <div >
                    {this.state.ticketCtrl !== undefined && this.state.ticketCtrl.map((value, index) => {
                        return (
                            <div className='row-start' key={index}>
                                <h2>Count: {value.count}</h2>
                                <h2>Price: {value.price}</h2>
                            </div>
                        )
                    })}
                </div>




                {/* <Link
                    to={{
                        pathname: "/events",

                    }}
                    onClick={(e) => {
                        const condition = (this.state.title === '' ||/* this.state.price < 0 || this.state.price === '' || this.state.description === '' || this.state.timeStart === '' || this.state.timeEnd === '' || this.state.address === '' || this.state.city === '' || this.state.date === '' || this.state.flyer === '' || this.state.state_ === '' || this.state.zipCode === '');
                        // if (condition) e.preventDefault();
                        // else {
                        //     setTimeout(() => {
                        //         console.log(`Waiting for image upload`)
                        //     }, 5000)
                        // }
                    // }}> */}
                <Button className="button"
                    variant="success"
                    style={{ padding: 0, }}
                    onClick={async () => {
                        this.uploadFlyer();
                        console.log(`Waiting for event upload`)
                        setTimeout(() => {
                            this.onSubmit();
                            setTimeout(() => {
                                console.log("Hopefully done")
                            }, 3000)
                        }, 2000)

                    }}>Create Event</Button>
                {/* </Link> */}

                <div style={{ paddingBottom: 20 }} />


            </div>
        )
    }
};